/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Arbeitsmoeglichkeiten_Erkunden33Inputs */

const en__field_enum_tuda_arbeitsmoeglichkeiten_erkunden33 = /** @type {(inputs: _Field_Enum_Tuda_Arbeitsmoeglichkeiten_Erkunden33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`discover employment opertunuties in Rhein-Mein area`)
};

const de__field_enum_tuda_arbeitsmoeglichkeiten_erkunden33 = /** @type {(inputs: _Field_Enum_Tuda_Arbeitsmoeglichkeiten_Erkunden33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsmöglichkeiten im Rhein-Main-Gebiet erkunden`)
};

/**
* | output |
* | --- |
* | "discover employment opertunuties in Rhein-Mein area" |
*
* @param {_Field_Enum_Tuda_Arbeitsmoeglichkeiten_Erkunden33Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_arbeitsmoeglichkeiten_erkunden33 = /** @type {((inputs?: _Field_Enum_Tuda_Arbeitsmoeglichkeiten_Erkunden33Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Arbeitsmoeglichkeiten_Erkunden33Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_arbeitsmoeglichkeiten_erkunden33(inputs)
	return de__field_enum_tuda_arbeitsmoeglichkeiten_erkunden33(inputs)
});
export { _field_enum_tuda_arbeitsmoeglichkeiten_erkunden33 as "_field_enum_TUDA_ARBEITSMOEGLICHKEITEN_ERKUNDEN" }